import { Disclosure, Transition } from "@headlessui/react";
import { ChevronRightIcon } from "lucide-react";
import { useEffect, useState } from "react";
import { getConfigSavings } from "../../../core/service/api_saving";
import { formatCurrency } from "../../../config/global";
import { TotalroundIcon } from "../../savingComponent/icons";
import { StatCard } from "./statCardComponents";
import { useTranslation } from "react-i18next";

interface SavingInformationProps {
  data: SavingsConfig;
  savingsAccount: any;
  hasBorder?: boolean;
}

interface SavingsConfig {
  id: string;
  companyId: string;
  savingName: string;
  coa: Coa;
  category: string;
  frequency: string;
  balanceSource: string;
  maxBalanceLimit: number;
  tags: null;
  startDate: null;
  endDate: null;
  periodDate: number;
  canWithdrawAnytime: boolean;
  withdrawableStartDate: null;
  active: boolean;
  minBalanceSaving: number;
  minBalanceSavingAutomatic: number;
  createdAt: null;
  updatedAt: Date;
  deleted: boolean;
  unlimitedMaxBalance: boolean;
  automatic: boolean;
}

interface Coa {
  code: string;
  coaCategory: CoaCategory;
  name: string;
  type: string;
  protected: boolean;
}

interface CoaCategory {
  id: string;
  name: string;
}

export const SavingInformationComponent = ({
  data,
  savingsAccount,
  hasBorder,
}: SavingInformationProps) => {
  const [savingsData, setSavingsData] = useState<SavingsConfig>(
    {} as SavingsConfig,
  );

  const { t } = useTranslation();

  useEffect(() => {
    console.log(data);

    if (data) {
      setSavingsData(data);
    }
  }, [data]);

  return (
    <>
      <div className="">
        <Disclosure defaultOpen>
          {({ open }) => (
            <>
              <Disclosure.Button className="flex w-full justify-between rounded-lg bg-purple-100 py-2 text-left text-base font-medium text-dark hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500/75">
                <span>{t("SAVING.information")}</span>
                <ChevronRightIcon
                  className={`${
                    open ? "rotate-90 transform" : ""
                  } h-5 w-5 text-dark`}
                />
              </Disclosure.Button>

              <Transition
                show={open}
                enter="transition-[max-height] duration-300 ease-in-out overflow-hidden"
                enterFrom="max-h-0"
                enterTo="max-h-40" // Sesuaikan dengan perkiraan tinggi konten
                leave="transition-[max-height] duration-300 ease-in-out overflow-hidden"
                leaveFrom="max-h-40"
                leaveTo="max-h-0"
              >
                <Disclosure.Panel>
                  <div className="w-full mt-4 flex flex-col gap-3">
                    <div
                      className={`w-full rounded-2xl bg-white p-3 items-center mx-auto flex justify-between ${hasBorder ? "border-1" : ""}`}
                    >
                      <span className="text-sm">{savingsData?.savingName}</span>
                      <TotalroundIcon />
                    </div>
                    <div className="grid grid-cols-2 gap-1">
                      <StatCard
                        hasBorder={true}
                        label={t("SAVING.currentBalance")}
                        value={formatCurrency(savingsAccount?.balance)}
                      />
                      <StatCard
                        hasBorder={true}
                        label={t("SAVING.minimum")}
                        value={formatCurrency(savingsData?.minBalanceSaving)}
                      />
                      <StatCard
                        hasBorder={true}
                        label={t("SAVING.max")}
                        value={formatCurrency(savingsData?.maxBalanceLimit)}
                      />
                      <StatCard
                        hasBorder={true}
                        label="Status"
                        format="text-base font-bold text-blue-700"
                        value={
                          savingsData?.active ? t("SAVING.active") : "Inactive"
                        }
                      />
                    </div>
                  </div>
                </Disclosure.Panel>
              </Transition>
            </>
          )}
        </Disclosure>
      </div>
    </>
  );
};
